import { BIG_CALENDAR_VIEW } from '@shared/ui'

export const CALENDAR_DAYS_FILTER = Object.freeze({
  [BIG_CALENDAR_VIEW.day]: 1,
  [BIG_CALENDAR_VIEW.workWeek]: 7,
  [BIG_CALENDAR_VIEW.month]: 30,
})
